var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-navigation',{ref:"navigation"}),(_vm.user_loaded)?_c('v-main',[_c('router-view')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }